
export const DocumentApprovalStatus = {
    APPROVED: 'APPROVED',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED',
    SEND_BACK: 'SEND_BACK'
};
